export default __webpack_public_path__ + "static/media/0007.fa11fe42.svg";